import React from 'react'
import SocialAppContainer from '../../../Components/Apps/SocialApp'

export default function SocialApp() {
  return (
    <div className='page-body'>
        <SocialAppContainer/>
    </div>
  )
}
